<template>
  <card>
    <div slot="header">
      <h4 class="title">Users Setup</h4>
    </div>
    <Users-Table/>
  </card>
</template>

<script>
export default {
  name: 'Users-Setup'
}
</script>

<style>

</style>